// extracted by mini-css-extract-plugin
module.exports = {"headerColumn":"style-module_headerColumn__gyjmWw0zq00OQQKrMaEA","rowColumn":"style-module_rowColumn__djxaNhcIe2RmuY14ildi","feedName":"style-module_feedName__LANJ00wQyCRWCiGbCET_"};